/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TagLangViewModel } from "../types/TagLangViewModel.ts";

export const tagLangViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  tagId: z.optional(z.number().int()),
  tagTitle: z.string().nullish(),
  cultureInfo: z.string().nullish(),
  cultureDisplayName: z.string().nullish(),
}) as unknown as ToZod<TagLangViewModel>;
